import { Routes, Route, useLocation } from "react-router-dom";
import Home from './pages/Home';
import Otel from './pages/Otel';
import Factory from './pages/Factory';
import ManagedServices from './pages/ManagedServices';
import Deployment from './pages/Deployment';
import PrivateFiveG from './pages/PrivateFiveG';
import Support from './pages/Support';
import PageNotFound from './pages/PageNotFound';
import { AnimatePresence } from "framer-motion";

function App() {
  const location = useLocation();

  return (
    <>
      <AnimatePresence>
        <Routes key={location.pathname} location={location}>
          <Route exact path="/" element={<Home />} />
          <Route exact path="/otel" element={<Otel />} />
          <Route exact path="/factory" element={<Factory />} />
          <Route exact path="/deployment" element={<Deployment />} />
          <Route exact path="/managed-services" element={<ManagedServices />} />
          <Route exact path="/support" element={<Support />} />
          <Route exact path="/private-5g" element={<PrivateFiveG />} />
          <Route path="*" element={<PageNotFound />} />
        </Routes>
      </AnimatePresence>
    </>
  );
}

export default App;
